<template>
  <div :class='$style.container' id='contact'>
    <container :class='$style.content' num='06' title='联系我们'>
      <div :class='$style.item'>
        <p :class='$style.title'>地址：</p>
        <p :class='$style.desc'>{{address}}</p>
      </div>
      <div :class='$style.item'>
        <p :class='$style.title'>电话：</p>
        <a :class='$style.desc' :href='`tel:${phone}`'>{{phone}}</a>
      </div>
      <div :class='$style.item'>
        <p :class='$style.title'>商务合作：</p>
        <p :class='$style.desc'>使用微信扫描二维码</p>
      </div>
      <div :class='$style.qrcodeContainer'>
        <div :class='$style.qrcodeItem'>
          <lazy-image :class='$style.qrcode' :src='require("../assets/13305185550.png")' />
          <p>{{phone1}}</p>
          <p>(零售团购)</p>
        </div>
        <div :class='$style.qrcodeItem'>
          <lazy-image :class='$style.qrcode' :src='require("../assets/19821798128.jpg")' />
          <p>{{phone2}}</p>
          <p>(批发)</p>
        </div>
      </div>
    </container>
    <lazy-image :class='$style.position' :src='require("../assets/position.jpg")' />
  </div>
</template>

<script>
import Container from "./Container";
export default {
  name: "Contact",
  components: { Container },
  data() {
    return {
      phone1: "",
      phone2: "",
      phone: "",
      address: ""
    };
  },
  mounted() {
    let { phone1, phone2, phone } = phones;
    this.phone1 = phone1;
    this.phone2 = phone2;
    this.phone = phone;
    this.address = company.address;
  }
};
</script>

<style lang='scss' module>
@import "../tool";
@media screen and(max-width:750px) {
  .container {
    flex-direction: column;
  }
  .position {
    margin-top: rem(20);
    width: 100% !important;
  }
}
.container {
  margin-top: 72px;
  padding-bottom: 30px;
  display: flex;
}
.content {
  flex: 1;
}
.item {
  color: #333;
}
.item ~ .item {
  margin-top: 24px;
}
.title {
  font-size: 16px;
  font-weight: 700;
}
.desc {
  font-size: 14px;
}
.qrcodeContainer {
  margin-top: 12px;
  display: flex;
}
.qrcode {
  width: 136px;
  height: 136px;
}
.qrcodeItem {
  flex: 1;
}
.position {
  width: 50%;
  height: 100%;
}
</style>